import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { loadNamespace, loadRequiredNamespaces } from '../../i18n';

const Wrapper = styled('div')`
  display: inline-block;
  cursor: pointer;
  padding: 8px 10px;
  font-size: 14px;

  .code {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    line-height: 15px;
    font-weight: 700;
    margin-left: 3px;
  }

  .arrow {
    position: relative;
    border-style: solid;
    border-width: 4px;
    border-color: transparent;
    border-top: 4px solid #a7acb2;
    border-bottom-width: 0;
    margin-top: auto;
    margin-bottom: 3px;
    margin-left: 1px;
  }

  .dropdown {
    position: absolute;
    top: 10px;
    left: -74px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    min-width: 120px;
  }

  .triangle {
    position: absolute;
    top: -6px;
    left: 73px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    pointer-events: none;
  }

  .triangle::before {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #ddd;
  }

  .triangle::after {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 1px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #fff;
  }

  .option {
    padding: 8px 12px;
    white-space: nowrap;
  }

  .flag {
    height: 13px;
    width: 19px;
    cursor: pointer;
    border: 0.5px solid #e3e6e9ff;
    background-repeat: no-repeat;
  }

  .ru {
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5MDAgNjAwIj48cmVjdCB3aWR0aD0iOTAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2ZmZiIvPjxyZWN0IHk9IjIwMCIgd2lkdGg9IjkwMCIgaGVpZ2h0PSIyMDAiIGZpbGw9IiMwMDM3QTciLz48cmVjdCB5PSI0MDAiIHdpZHRoPSI5MDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRTAxQzI1Ii8+PC9zdmc+');
  }

  .cn {
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5MDAgNjAwIj48cmVjdCB3aWR0aD0iOTAwIiBoZWlnaHQ9IjYwMCIgZmlsbD0iI0UwMUMyNSIvPjxwYXRoIGQ9Ik0xODAgMzAwTDE1MCAzNTBMMjEwIDM1MFoiIGZpbGw9IiNGRkZGMDAiLz48Y2lyY2xlIGN4PSIxODAiIGN5PSIzMDAiIHI9IjMwIiBmaWxsPSIjRkZGRjAwIi8+PHBhdGggZD0iTTE1MCAyNTBMMTIwIDMwMEwxODAgMzAwWiIgZmlsbD0iI0ZGRkYwMCIvPjwvc3ZnPg==');
  }

  .header-wrap {
    display: flex;
  }

  input[type='radio'] {
    appearance: none;
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid #a7acb2;
    border-radius: 50%;
    outline: none;
    cursor: pointer;
  }

  input[type='radio']:checked {
    background-color: #7e57c2;
    box-shadow: inset 0 0 0 2px white;
    border: 1px solid transparent;
  }

  .lang-label {
    margin-top: 1px;
  }
`;

const LANGUAGES = [
  { code: 'ru', label: '俄语 - RU' },
  { code: 'cn', label: '中文  - CN' },
];

const LocaleSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const currentLanguage = LANGUAGES.find((lang) => lang.code === i18n.language);

  const handleChangeLanguage = async (code) => {
    localStorage.setItem('locale', code);
    await loadRequiredNamespaces(code);
    await i18n.changeLanguage(code);
  };

  return (
    <Wrapper className={className}>
      <div
        className="header-wrap"
        onClick={() => setIsOpen(!isOpen)}
        onMouseEnter={() => setIsOpen(true)}
      >
        <div className={`flag ${currentLanguage?.code}`} />
        <span className="code">{currentLanguage?.label || 'Language'}</span>
        <div className="arrow">
          {isOpen && (
            <div className="dropdown" onMouseLeave={() => setIsOpen(false)}>
              <div className="triangle"></div>
              {LANGUAGES.map((lang) => (
                <div
                  key={lang.code}
                  className={`d-flex align-items-center option ${
                    i18n.language === lang.code ? 'active' : ''
                  }`}
                  onClick={() => handleChangeLanguage(lang.code)}
                >
                  <input
                    className="radio mr-1"
                    type="radio"
                    id={lang.code}
                    name="color-picker"
                    checked={i18n.language === lang.code}
                  />
                  <span className="lang-label">{lang.label}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  );
};

export default LocaleSwitcher;
